import { createSelector } from '../utils/selector-utils'

/**
 * @param {SedationLevel} depth The rxcui ID of the drug we're selecting
 * @returns {any} The changes to apply to the case.
 */
export const actionUpdateSedationLevel = depth => ({
  sedationLevel:
    {
      local: 'Local',
      minimal: 'Minimal',
      moderate: 'Moderate',
      deep: 'Deep',
      ga: 'GA',
    }[depth] || null,
})

/**
 * @param {CaseData} caseData The case data to select from
 * @returns {SedationLevelCased} The sedation level of the case
 */
export const selectSedationLevel = caseData => caseData.sedationLevel || null

/**
 * @param {CaseData} caseData The case data to select from
 * @returns {boolean} Whether the patient is being sedated
 */
export const selectSedativesBeingUsed = createSelector(
  selectSedationLevel,
  level => level !== 'Local'
)

/**
 * @param {CaseData} caseData The case data to select from
 * @returns {boolean} Whether the patient is being sedated
 */
export const selectHasRecoveryPhase = selectSedativesBeingUsed
